import axios from 'axios';

export default {
	pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garctactebene.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	recuperar(p_email, p_usuario, p_beneficiario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garctactebene.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_beneficiario": p_beneficiario
                    
				  })
			})
	},
	
	buscarBeneficiario(p_email, p_pais, p_nombre, p_idnacion, p_codigo, p_tipo, p_codaseg) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garctactebene.sp_buscar_persona",
				"p_args_in": JSON.stringify({
					"p_pais": p_pais,
                    "p_nombre": p_nombre,
					"p_idnacion": p_idnacion,
					"p_codigo": p_codigo,
					"p_tipo": p_tipo,
					"p_codaseg": p_codaseg 
				  })
			})
	},
	
	modificarPeso(p_email, p_usuario, p_beneficiario, p_moneda, p_banco, p_cuenta, p_libre, p_tipocuenta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garctactebene.modificarPeso",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_beneficiario": p_beneficiario,
					"p_moneda": p_moneda,
					"p_banco": p_banco,
					"p_cuenta": p_cuenta,
					"p_libre": p_libre,
					"p_tipocuenta": p_tipocuenta
				  })
			})
	},
	
	modificar(p_email, p_usuario, p_beneficiario, p_moneda, p_libre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garctactebene.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_beneficiario": p_beneficiario,
					"p_moneda": p_moneda,
					"p_libre": p_libre
				  })
			})
    },

    
}